import { StoreIdentifyYourselfValue } from '../types/store';

export const IDENTIFY_YOURSELF = [
  { value: StoreIdentifyYourselfValue.STARTING_OUT, label: "Haven't started selling yet (pre-sales)" },
  { value: StoreIdentifyYourselfValue.YEARLY_SALES_0K_10K, label: '$0 - $10K in sales/yr' },
  { value: StoreIdentifyYourselfValue.YEARLY_SALES_10K_100K, label: '$10K - $100K in sales/yr' },
  { value: StoreIdentifyYourselfValue.YEARLY_SALES_100K_500K, label: '$100K - $500K in sales/yr' },
  { value: StoreIdentifyYourselfValue.YEARLY_SALES_500K_2M, label: '$500K - $2M in sales/yr' },
  { value: StoreIdentifyYourselfValue.YEARLY_SALES_2M_5M, label: '$2M - $5M in sales/yr' },
  { value: StoreIdentifyYourselfValue.YEARLY_SALES_5M_ABOVE, label: 'More than $5M in sales/yr' },
];

export const INTERESTED_SERVICES = [
  { value: 'SOURCING', label: 'Source products & packaging' },
  { value: 'FULFILLMENT', label: 'Save money on storage & fulfillment' },
  { value: 'SET_UP_STOREFRONT', label: 'Set up a storefront' },
  { value: 'SALES_CHANNEL', label: 'Set up marketing tools' },
  { value: 'SPECIFIC_PROJECT', label: 'A specific project like making merch' },
  { value: 'CREATE_AN_ECOMM_BRAND', label: 'Educate me with a step-by-step guide to start a brand' },
];

export const HEAR_FROM_OPTIONS = [
  { value: 'GOOGLE', label: 'Google' },
  { value: 'SOCIAL_MEDIA', label: 'Social Media' },
  { value: 'NEWSLETTER', label: 'Newsletters' },
  { value: 'PODCAST', label: 'Podcast' },
  { value: 'YOUTUBE', label: 'YouTube' },
  { value: 'EVENT', label: 'Events' },
  { value: 'WORD_OF_MOUTH', label: 'Word of mouth' },
  { value: 'PIETRA_TEAM_CONTACTED_ME', label: 'Pietra team contacted me' },
  { value: 'OTHER', label: 'Other' },
];

export const ANNUAL_SALES_OPTIONS = [
  { value: 'Just Started', label: 'Just Started' },
  { value: '$10K - $100K', label: '$10K - $100K' },
  { value: '$100K - $500K', label: '$100K - $500K' },
  { value: '$500K - $2M', label: '$500K - $2M' },
  { value: '$2M - $5M', label: '$2M - $5M' },
  { value: '$5M+', label: '$5M+' },
];

export const TEAM_SIZE_OPTIONS = [
  { value: '1', label: '1' },
  { value: '2-5', label: '2-5' },
  { value: '6-10', label: '6-10' },
  { value: '10+', label: '10+' },
];

export enum INTERESTED_SERVICES_KEYS {
  SOURCING_PRODUCTION = 'Sourcing & Production',
  LOGISTICS_FULFILLMENT = 'Logistics & Fulfillment',
  MARKETING_TOOLS = 'Marketing Tools',
}

export const SERVICES_OF_INTEREST_OPTIONS = [
  { value: INTERESTED_SERVICES_KEYS.SOURCING_PRODUCTION, label: INTERESTED_SERVICES_KEYS.SOURCING_PRODUCTION },
  { value: INTERESTED_SERVICES_KEYS.LOGISTICS_FULFILLMENT, label: INTERESTED_SERVICES_KEYS.LOGISTICS_FULFILLMENT },
  { value: INTERESTED_SERVICES_KEYS.MARKETING_TOOLS, label: INTERESTED_SERVICES_KEYS.MARKETING_TOOLS },
];

export const CURRENTLY_HANDLING_SOURCING_OPTIONS = [
  { value: 'Self-sourcing', label: 'Self-sourcing' },
  { value: 'In-House Department', label: 'In-House Department' },
  { value: 'External Agency', label: 'External Agency' },
  { value: 'Other', label: 'Other' },
];
export const CURRENTLY_HANDLING_FULFILLMENT_OPTIONS = [
  { value: 'Self-fulfillment', label: 'Self-fulfillment' },
  { value: 'ShipBob', label: 'ShipBob' },
  { value: 'ShipHero', label: 'ShipHero' },
  { value: 'ShipMonk', label: 'ShipMonk' },
  { value: 'Other', label: 'Other' },
];

export const MONTHLY_FULFILLMENT_VOLUME_OPTIONS = [
  { value: '0', label: '0' },
  { value: '1-100', label: '1 - 100' },
  { value: '101-500', label: '101 - 500' },
  { value: '501-1000', label: '501 - 1000' },
  { value: '1001-5000', label: '1001 - 5000' },
  { value: '5000+', label: '5000+' },
];
